<template>
    <div>
        <v-row>
            <v-card max-width="400" class="ma-3" tile v-if="users">
                <v-list-item @click="getWrikeUsers">
                    <v-list-item-icon>
                        <v-icon>fas fa-redo</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Brukere i Wrike</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
    
                <template v-if="wrikeusers">
                    <v-list-item v-for="user in wrikeusers" :key="user.id" v-if="!user.deleted">
                        <v-list-item-avatar>
                            <v-img :src="user.avatarUrl"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content :to="'/?user='+user.id">
                            <v-list-item-title>{{user.firstName}} {{user.lastName}}</v-list-item-title>
                            <v-list-item-subtitle></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-btn icon  @click="updateUser(user)">
                                <v-icon>fas fa-arrow-alt-circle-right</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-card>
    
            <v-card max-width="400" class="ma-3" tile>
                <v-list-item @click="getGuruUsers">
                    <v-list-item-icon>
                        <v-icon>fas fa-redo</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Brukere i GuruWrike</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
        
                <template v-if="users">
                    <v-list-item v-for="(user, index) in users" :key="user.wrike.id" v-if="!user.wrike.deleted" @click="editUserIndex = index">
                        <v-list-item-avatar>
                            <v-img :src="user.wrike.avatarUrl"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{user.wrike.firstName}} {{user.wrike.lastName}}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="user.access">{{user.access.join(", ")}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-card>
    
            <v-card max-width="400" class="ma-3" tile v-if="editUserIndex != null">
    
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="3">
                            <v-avatar avatar>
                                <img :src="editUser.wrike.avatarUrl" :alt="`${editUser.wrike.firstName} ${editUser.wrike.lastName}`">
                            </v-avatar>
                        </v-col>
                        <v-col class="display-1" cols="9">
                            {{editUser.wrike.firstName}} {{editUser.wrike.lastName}}
                        </v-col>
                    </v-row>
                    <v-text-field
                        label="Avdeling"
                        v-model="editUser.info.department"
                        type="text"
                    ></v-text-field>
                    <v-btn @click="saveEditUser()" :loading="userIsSaving">Save</v-btn>
                    <v-btn @click="deleteGuruUser()" :loading="userIsSaving">Delete</v-btn>
                </v-card-text>
        
                
                <v-list-item two-line v-for="access in accesses" :key="access">
                    <v-list-item-action>
                        <v-switch
                                :disabled="loading"
                                :loading="loading ? 'primary' : false"
                                :key="access+editUserIndex"
                                v-model="editUser.access"
                                :value="access"
                                @change="saveAccess(access)"
                        ></v-switch>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{access}}</v-list-item-title>
                        <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                
            </v-card>
            
            <v-card max-width="400" class="ma-3" tile>
                <v-card-text>
                    <v-text-field
                            label="Opprett Nytt Team"
                            @click:append="addTeam"
                            v-model="teamName"
                            type="text"
                            append-icon="fas fa-plus"
                    ></v-text-field>
                </v-card-text>
                <template v-for="(team, index) in teams">
                    <v-text-field v-model="team.name" label="Team navnet"></v-text-field>
                    <v-select
                            v-model="teams[index].users"
                            :items="users"
                            :item-text="i => i.wrike.firstName + ' ' + i.wrike.lastName"
                            :item-value="i => i.wrike.id"
                            attach
                            chips
                            :label="'Medlemer til ' + team.name"
                            multiple
                    >
                    </v-select>
                    <v-btn @click="saveTeam(index)" :loading="teamsLoading">Save</v-btn>
                    <hr class="ma-8">
                </template>
                
            </v-card>
        </v-row>
    </div>
</template>
<script>
    import api from '@/api'
    export default{
        name:'Manager',
        data(){
            return {
                wrikeusers: [],
                users: [],
                accesses: ["login", "dashboard", "users", "teams", "invoice", "simpleinvoice", "manager"],
                editUserIndex: null,
                loading: false,
                teams: [],
                teamsLoading: false,
                teamName: '',
                userIsSaving: false
            }
        },
        computed:{
            editUser(){
                if(this.editUserIndex == null) return null
                let user = this.users[this.editUserIndex]
                if(!user.info) user.info = {}
                return user
            }
        },
        methods:{
            saveTeam(teamIndex){
                this.teamsLoading = true
                api.POST('/teams', this.teams[teamIndex])
                    .then(data => this.teams.splice(teamIndex, data))
                    .finally(() => this.teamsLoading = false)
            },
            addTeam(){
                this.teams.push({name:this.teamName, users: []})
            },
            hasAccess(access){
                return this.editUser.access ? this.editUser.access.indexOf(access) > -1 : false
            },
            saveAccess(access){
                this.loading = true
                if(this.hasAccess(access)) {
                    api.PUT('/users/' + this.editUser.wrike.id + "/access", {access})
                        .then(data => {
                            this.users.splice(this.editUserIndex, 1, data)
                            this.loading = false
                        })
                }else{
                    api.DELETE('/users/' + this.editUser.wrike.id + "/access/" + access)
                        .then(data => {
                            this.users.splice(this.editUserIndex, 1, data)
                            this.loading = false
                        })
                }
            },
            getWrikeUsers(){
                api.GET('/wrikeusers').then(data => this.wrikeusers = data.data)
            },
            getGuruUsers(){
                api.GET('/users').then(data => this.users = data)
            },
            deleteGuruUser(){
                this.userIsSaving = true
                api.DELETE('/user/' + this.editUser.wrike.id).then(() => this.getGuruUsers()).finally(() => this.userIsSaving = false)
            },
            saveEditUser(){
                this.userIsSaving = true
                api.POST('/user/' + this.editUser.wrike.id, this.editUser).then(data => {
                    let uIndex = this.users.findIndex(it => it.wrike.id === data.wrike.id)
                    if(uIndex > -1) this.users.splice(uIndex, 1, data)
                }).finally(() => this.userIsSaving = false)
            },
            getTeams(){
                this.teamsLoading = true
                api.GET('/teams').then(data => this.teams = data)
                    .finally(() => this.teamsLoading = false)
            },
            updateUser(user){
                let userIndex = this.users.findIndex(u => u.wrike.id === user.id)
                api.PUT('/user', user).then(data => {
                    if(userIndex > -1) this.users.splice(userIndex, 1, data)
                    else this.users.push(data)
                })
            }
        },
        mounted(){
            this.getGuruUsers()
            this.getTeams()
        }
    }
</script>